import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitobhimashankarcab() {



    const cardData = {

keyword: "Mumbai to Bhimashankar Cab",

headingDescription:
    "Mumbai Airport Cab offers safe, comfortable, and reliable Mumbai to Bhimashankar Cab services for pilgrimage travelers, families, groups, and nature lovers. We provide well-maintained Sedan, SUV, Innova Crysta, Ertiga, Tempo Traveller, Luxury Urbania, and Mini Bus options with experienced chauffeurs for a smooth journey through the scenic Western Ghats. With doorstep pickup across Mumbai, Mumbai Airport transfers, one-way and round-trip cab bookings, flexible travel plans, 24/7 customer support, and transparent pricing, we ensure a peaceful and hassle-free pilgrimage to Shri Bhimashankar Jyotirlinga and nearby attractions.",

topPlaces: [
    {
        title: "Bhimashankar Jyotirlinga Temple",
        description:
            "Bhimashankar Jyotirlinga is one of the twelve sacred Jyotirlingas of Lord Shiva and a major pilgrimage destination in Maharashtra. Located in the Sahyadri hills, the temple is surrounded by dense forests and rich biodiversity. Devotees visit throughout the year to seek blessings in a serene and spiritual atmosphere. The temple architecture, religious rituals, and peaceful surroundings make it the highlight of the Mumbai to Bhimashankar cab journey."
    },
    {
        title: "Bhimashankar Wildlife Sanctuary",
        description:
            "The Bhimashankar Wildlife Sanctuary is a protected forest area known for its rich flora and fauna, including the rare Indian Giant Squirrel (Shekru), birds, butterflies, and diverse plant species. Nature lovers and eco-tourists enjoy exploring its trekking trails and forest routes. The sanctuary adds an adventurous and natural experience to the spiritual trip to Bhimashankar."
    },
    {
        title: "Hanuman Lake",
        description:
            "Hanuman Lake is a peaceful natural attraction near Bhimashankar, surrounded by dense greenery and calm waters. It is believed to be a sacred spot linked with Lord Hanuman and offers a quiet environment for relaxation and nature observation. Visitors often stop here to enjoy scenic beauty and take a break during their pilgrimage journey."
    },
    {
        title: "Gupt Bhimashankar",
        description:
            "Gupt Bhimashankar is a lesser-known sacred site located in the forest area, believed to be the original hidden Jyotirlinga shrine. The place is surrounded by dense vegetation and requires a short trek through nature trails. Devotees visit this spiritual spot for meditation, peace, and a deeper connection with the holy surroundings."
    },
    {
        title: "Shidi Ghat (Bhimashankar Trek Route)",
        description:
            "Shidi Ghat is a steep trekking route leading to Bhimashankar temple, known for its challenging rock patches and scenic forest views. Adventure seekers and trekkers enjoy this route for its thrilling climb and natural beauty. It offers a unique combination of pilgrimage and adventure for travelers visiting from Mumbai."
    },
    {
        title: "Ahupe Waterfall",
        description:
            "Ahupe Waterfall is a seasonal waterfall located near Bhimashankar, surrounded by lush green valleys and hills. It becomes especially beautiful during the monsoon season when water flows strongly, creating a breathtaking natural view. Tourists and photographers often visit this spot for its scenic beauty and peaceful environment."
    },
    {
        title: "Siddhagad Fort",
        description:
            "Siddhagad Fort is a historic hill fort located near Bhimashankar, known for its trekking routes and panoramic views of the Sahyadri ranges. The fort has historical significance and offers a rewarding experience for adventure lovers. The combination of history, trekking, and natural beauty makes it a popular attraction in the region."
    },
    {
        title: "Pali Ashtavinayak Ganpati Temple",
        description:
            "The Pali Ashtavinayak Ganpati Temple is one of the eight sacred temples of Lord Ganesha and is often included in pilgrimage tours along with Bhimashankar. The temple is dedicated to Lord Ballaleshwar and is known for its spiritual importance, traditional architecture, and peaceful surroundings."
    },
    {
        title: "Rajgad & Torna Fort Viewpoints",
        description:
            "The surrounding Sahyadri range near Bhimashankar offers distant views of historic forts like Rajgad and Torna. These viewpoints are popular among nature lovers and trekkers who enjoy the scenic landscapes, misty hills, and natural beauty during the journey from Mumbai."
    },
    {
        title: "Khed & Manchar Rural Belt",
        description:
            "The route from Mumbai to Bhimashankar passes through Khed and Manchar regions, known for rural Maharashtra landscapes, small villages, and green agricultural fields. Travelers experience peaceful countryside views, local culture, and authentic Maharashtrian lifestyle during the scenic road trip."
    }
],



services: [
{
name: "Mumbai to Bhimashankar Cab",
description: "Mumbai Airport Cab offers Mumbai to Bhimashankar Cab service for comfortable and safe pilgrimage and leisure travel to one of Maharashtra’s most famous Jyotirlinga destinations. We provide well-maintained AC Sedan, Ertiga, Innova Crysta, Kia Carens, SUV, and luxury vehicles with professional chauffeurs, doorstep pickup, flexible timing, and 24x7 booking support. Our service is ideal for family trips, temple visits, weekend getaways, and group travel with one way and round trip options designed for a smooth and stress-free journey."
},
{
name: "Mumbai to Bhimashankar Taxi",
description: "Book Mumbai to Bhimashankar Taxi with Mumbai Airport Cab for reliable and affordable outstation travel. Our experienced drivers ensure safe hill-route driving, while our comfortable AC vehicles make long-distance travel easy for families, tourists, and senior citizens visiting Bhimashankar temple."
},
{
name: "Mumbai to Bhimashankar Car Rental",
description: "Mumbai Airport Cab provides Mumbai to Bhimashankar Car Rental service with chauffeur-driven vehicles for flexible travel plans. Choose from Sedan, SUV, Innova Crysta, and premium cars suitable for pilgrimage tours, family trips, and private travel with full comfort and convenience."
},
{
name: "Mumbai to Bhimashankar Taxi Fare",
description: "Get transparent Mumbai to Bhimashankar Taxi Fare with Mumbai Airport Cab and enjoy budget-friendly pricing with no hidden charges. We offer fixed-rate packages for one way and round trip journeys, ensuring affordable travel with premium service quality and clean AC vehicles."
},
{
name: "Mumbai to Bhimashankar Taxi Cost",
description: "Check Mumbai to Bhimashankar Taxi Cost with Mumbai Airport Cab for economical and premium travel options. Our pricing depends on vehicle type and trip duration, offering flexible packages for Sedan, Ertiga, Innova Crysta, and SUV categories suitable for all budgets."
},
{
name: "Taxi Fare from Mumbai to Bhimashankar",
description: "Mumbai Airport Cab provides clear Taxi Fare from Mumbai to Bhimashankar with transparent billing and competitive pricing. Our fare structure ensures value-for-money travel with experienced drivers, safe vehicles, and comfortable long-distance journeys."
},
{
name: "Mumbai to Bhimashankar Taxi Service",
description: "Our Mumbai to Bhimashankar Taxi Service ensures safe, punctual, and comfortable travel with professional chauffeurs and a fleet of well-maintained AC vehicles. Ideal for family trips, pilgrimage tours, and weekend travel with customizable pickup and drop options."
},
{
name: "Mumbai to Bhimashankar One Way Cab",
description: "Book Mumbai to Bhimashankar One Way Cab with Mumbai Airport Cab for affordable drop-only travel. Enjoy fixed pricing, AC comfort, experienced drivers, and hassle-free booking with multiple vehicle options for individuals and families."
},
{
name: "Mumbai to Bhimashankar Cab Booking",
description: "Mumbai Airport Cab offers Mumbai to Bhimashankar Cab Booking with instant confirmation, flexible scheduling, and 24x7 customer support. Choose from Sedan, SUV, Innova Crysta, Kia Carens, and Tempo Traveller for convenient travel."
},
{
name: "Mumbai to Bhimashankar Outstation Cab",
description: "Mumbai Airport Cab provides Mumbai to Bhimashankar Outstation Cab service for safe long-distance travel with professional chauffeurs, comfortable vehicles, and customized pilgrimage tour packages designed for families and groups."
},
{
name: "Mumbai Airport to Bhimashankar Cab",
description: "Book Mumbai Airport to Bhimashankar Cab for direct pickup from domestic and international terminals. We offer flight tracking, punctual service, and comfortable AC vehicles for smooth onward travel to Bhimashankar temple."
},
{
name: "Navi Mumbai to Bhimashankar Cab",
description: "Mumbai Airport Cab provides Navi Mumbai to Bhimashankar Cab service with affordable pricing, reliable chauffeurs, and comfortable vehicles for one way and round trip journeys."
},
{
name: "Thane to Bhimashankar Cab",
description: "Book Thane to Bhimashankar Cab with Mumbai Airport Cab for safe and convenient travel with doorstep pickup, experienced drivers, and well-maintained AC cars suitable for family and pilgrimage trips."
},
{
name: "Panvel to Bhimashankar Taxi",
description: "Mumbai Airport Cab offers Panvel to Bhimashankar Taxi service with comfortable vehicles and professional chauffeurs ensuring smooth travel to the temple and surrounding tourist spots."
},
{
name: "Kalyan to Bhimashankar Cab",
description: "Choose Kalyan to Bhimashankar Cab with Mumbai Airport Cab for reliable and affordable travel with flexible pickup options, clean vehicles, and experienced drivers."
},
{
name: "Dombivli to Bhimashankar Cab",
description: "Mumbai Airport Cab provides Dombivli to Bhimashankar Cab service with safe, punctual, and comfortable transportation options suitable for families and group travel."
},
{
name: "Borivali to Bhimashankar Taxi",
description: "Book Borivali to Bhimashankar Taxi with Mumbai Airport Cab for long-distance travel with professional chauffeurs, AC comfort, and flexible scheduling."
},
{
name: "Andheri to Bhimashankar Cab",
description: "Mumbai Airport Cab offers Andheri to Bhimashankar Cab service with door-to-door pickup, premium vehicles, and reliable outstation travel solutions for all customer needs."
}
],

tableData: [
["Mumbai to Bhimashankar Cab","Mumbai to Bhimashankar Taxi"],
["Mumbai to Bhimashankar Car Rental","Mumbai to Bhimashankar Taxi Cost"],
["Mumbai to Bhimashankar Taxi Fare","Taxi Fare from Mumbai to Bhimashankar"],
["Mumbai to Bhimashankar Taxi Service","Mumbai to Bhimashankar One Way Cab"],
["Mumbai to Bhimashankar Cab Booking","Mumbai to Bhimashankar Outstation Cab"],
["Mumbai Airport to Bhimashankar Cab","Navi Mumbai to Bhimashankar Cab"],
["Thane to Bhimashankar Cab","Panvel to Bhimashankar Taxi"],
["Kalyan to Bhimashankar Cab","Dombivli to Bhimashankar Cab"],
["Borivali to Bhimashankar Taxi","Andheri to Bhimashankar Cab"]
],




whychoose: [
{
WhyChooseheading: "Reliable Mumbai to Bhimashankar Cab Service",
WhyChoosedescription: "Mumbai Airport Cab Service provides dependable Mumbai to Bhimashankar Cab transportation for devotees, families, tourists, and groups visiting the sacred Bhimashankar Jyotirlinga Temple."
},
{
WhyChooseheading: "Comfortable Pilgrimage Travel Experience",
WhyChoosedescription: "Our cab service ensures a smooth and comfortable journey through scenic routes, making your spiritual trip relaxing and hassle-free."
},
{
WhyChooseheading: "Perfect for Bhimashankar Jyotirlinga Darshan",
WhyChoosedescription: "Thousands of devotees choose our Mumbai to Bhimashankar Cabs for convenient travel to one of the twelve sacred Jyotirlingas in India."
},
{
WhyChooseheading: "Wide Range of Vehicle Options",
WhyChoosedescription: "Customers can select Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles according to passenger count and travel requirements."
},
{
WhyChooseheading: "One-Way and Round Trip Facilities",
WhyChoosedescription: "Whether you require a one-way drop, same-day return, round trip, or customized pilgrimage package, we provide flexible booking options."
},
{
WhyChooseheading: "Pickup Available Across Mumbai",
WhyChoosedescription: "Doorstep pickup services are available from Mumbai Airport, Navi Mumbai, Thane, Andheri, Borivali, Dadar, Bandra, Powai, and nearby locations."
},
{
WhyChooseheading: "Safe and Professional Drivers",
WhyChoosedescription: "Our experienced drivers and regularly maintained vehicles ensure a safe, comfortable, and stress-free journey to Bhimashankar."
},
{
WhyChooseheading: "Suitable for Families and Religious Groups",
WhyChoosedescription: "From individual devotees to large pilgrimage groups, we provide suitable vehicle options for every type of religious travel."
}
]
};

const faqData = [
{
question: "Why do devotees book Mumbai to Bhimashankar Cabs?",
answer: "Bhimashankar is one of the twelve Jyotirlingas and attracts thousands of devotees seeking convenient and comfortable pilgrimage transportation."
},
{
question: "Can I book a one-way cab from Mumbai to Bhimashankar?",
answer: "Yes, one-way cab services are available along with round-trip and customized pilgrimage packages."
},
{
question: "Which vehicle is suitable for Mumbai to Bhimashankar travel?",
answer: "Sedan cars, Ertiga, and Innova Crysta are among the most popular choices for comfortable temple visits."
},
{
question: "Are same-day return trips available?",
answer: "Yes, customers can choose same-day return travel depending on their darshan schedule and requirements."
},
{
question: "Can families use this service for Bhimashankar Darshan?",
answer: "Yes, families frequently choose our Mumbai to Bhimashankar Cab Service for comfortable and convenient temple visits."
},
{
question: "Do you provide Tempo Travellers for group pilgrimages?",
answer: "Yes, Tempo Travellers and larger vehicles are available for religious groups, family tours, and pilgrimage travel."
},
{
question: "Can customers start the journey from Mumbai Airport?",
answer: "Yes, pickup services are available from Mumbai Airport, railway stations, hotels, offices, and residential locations."
},
{
question: "Is advance reservation recommended for Bhimashankar travel?",
answer: "Yes, advance booking helps secure preferred vehicles and ensures smooth pilgrimage planning."
},
{
question: "Can other religious destinations be included during the trip?",
answer: "Yes, customers can customize their journey by including Trimbakeshwar, Shirdi, Nashik, and other nearby pilgrimage destinations."
},
{
question: "How can I book a Mumbai to Bhimashankar Cab?",
answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cab Service."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Pravin Kulkarni",
feedback:
"We booked a Mumbai to Bhimashankar Cab for our family darshan trip. The vehicle was comfortable, the driver was polite, and the journey was smooth throughout.",
rating: 5
},
{
id: 2,
name: "Mrs. Manisha Deshmukh",
feedback:
"Mumbai Airport Cab Service provided an excellent Bhimashankar travel experience. The cab arrived on time, the driver was professional, and our darshan trip was completely hassle-free.",
rating: 5
}
];






























   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];










const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Mumbai to Bhimashankar Cab",
"image": "https://www.mumbaiairportcabs.com/assets/images/mumbai-to-bhimashankar-cab.jpg",
"description": "Book Mumbai to Bhimashankar cab service for a safe and comfortable pilgrimage journey. Mumbai Airport Cabs offers reliable taxi service with experienced drivers, clean vehicles, affordable fares, and convenient one-way and round-trip travel options to Bhimashankar Jyotirlinga Temple.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/mumbai-to-bhimashankar-cab"
}
};






    return (
        <div>


<Helmet>
  <title>Mumbai to Bhimashankar Cab | Taxi Service & Fare | +91 9545731161</title>

<meta
 name="description"
 content="Book Mumbai to Bhimashankar cab service at affordable fares. Reliable taxi service with professional drivers, comfortable cars, one-way and round-trip options, and convenient travel to Bhimashankar Temple."
/>

<meta
 name="keywords"
 content="mumbai to bhimashankar cab, mumbai to bhimashankar car rental, mumbai to bhimashankar taxi, mumbai to bhimashankar taxi cost, mumbai to bhimashankar taxi fare, taxi fare from mumbai to bhimashankar, mumbai to bhimashankar cab service, mumbai to bhimashankar taxi service, one way cab mumbai to bhimashankar, round trip taxi mumbai to bhimashankar, bhimashankar temple taxi from mumbai, cab booking mumbai to bhimashankar, affordable bhimashankar cab, outstation cab mumbai to bhimashankar, car hire mumbai to bhimashankar"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>









            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/106.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitobhimashankarcab;